import { useEffect } from 'react';
import { useAppSelector } from '@store';
import {
  useLazyGetProductsCorporateQuery,
  useGetProductsValidatorsCorporateQuery,
} from '../store/services';
import { RiskScoreClientTypeEnum } from '../../types';
import ProductsList from '../../partial/products/list';

const IndividualClientsProductsList = (): React.JSX.Element => {
  const {
    corporateClientsRisk: {
      products: {
        list: { values, pagination },
      },
    },
  } = useAppSelector((state) => state);

  useGetProductsValidatorsCorporateQuery();

  const [getProducts, { isLoading, isFetching }] =
    useLazyGetProductsCorporateQuery();

  useEffect(() => {
    let title = 'Corporate Products risk';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  return (
    <ProductsList
      list={values}
      pagination={pagination}
      getList={getProducts}
      isFetching={isFetching}
      clientType={RiskScoreClientTypeEnum.CORPORATE}
      isLoading={isLoading}
    />
  );
};

export default IndividualClientsProductsList;
